import React from "react";

const filterContext = React.createContext();

export default filterContext;
